/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Auto_FormatInputs */

const en_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto format the currently selected event based on the Event Group Settings`)
};

const fr_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formater automatiquement l'evenement selectionne selon les parametres du groupe`)
};

const de_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das aktuell ausgewählte Ereignis wird automatisch anhand der Ereignisgruppeneinstellungen formatiert.`)
};

const it_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatta automaticamente l'evento attualmente selezionato in base alle impostazioni del gruppo eventi`)
};

const ru_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование выбранного события на основе настроек группы событий.`)
};

const es_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatear automáticamente el evento seleccionado actualmente según la configuración del grupo de eventos`)
};

const zh_cn2_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据事件组设置自动格式化当前选定的事件`)
};

const ja_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ設定に基づいて現在選択されているイベントを自動フォーマットします`)
};

const hi_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट ग्रुप सेटिंग्स के आधार पर वर्तमान में चयनित इवेंट को स्वचालित रूप से फॉर्मेट करें`)
};

const pt_pt2_shortcut_keys_desc_auto_format = /** @type {(inputs: Shortcut_Keys_Desc_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatar automaticamente o evento selecionado com base nas configurações do grupo de eventos.`)
};

/**
* | output |
* | --- |
* | "Auto format the currently selected event based on the Event Group Settings" |
*
* @param {Shortcut_Keys_Desc_Auto_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_auto_format = /** @type {((inputs?: Shortcut_Keys_Desc_Auto_FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Auto_FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_auto_format(inputs)
	if (locale === "de") return de_shortcut_keys_desc_auto_format(inputs)
	if (locale === "it") return it_shortcut_keys_desc_auto_format(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_auto_format(inputs)
	if (locale === "es") return es_shortcut_keys_desc_auto_format(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_auto_format(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_auto_format(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_auto_format(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_auto_format(inputs)
	return en_shortcut_keys_desc_auto_format(inputs)
});